import React from 'react';
import { Result, Button } from 'antd';
import { RouteComponentProps } from 'react-router-dom';
import { useNavigate } from "react-router-dom-v5-compat";

export default function NotFound (props:RouteComponentProps) {
  const navigate = useNavigate()
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button
          type="primary"
          onClick={() => {
            navigate('/login');
          }}
        >
          Back Home
        </Button>
      }
    />
  );
}
